export const ProfileOutline = (props: any) => (
	<svg
		data-testid="svgProfileOutline"
		width="12"
		height="16"
		viewBox="0 0 12 16"
		fill="currentColor"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.33268 4.24996C9.33268 6.08829 7.83768 7.58329 5.99935 7.58329C4.16102 7.58329 2.66602 6.08829 2.66602 4.24996C2.66602 2.41163 4.16102 0.916626 5.99935 0.916626C7.83768 0.916626 9.33268 2.41163 9.33268 4.24996ZM5.99935 2.58329C6.91852 2.58329 7.66602 3.33079 7.66602 4.24996C7.66602 5.16913 6.91852 5.91663 5.99935 5.91663C5.08018 5.91663 4.33268 5.16913 4.33268 4.24996C4.33268 3.33079 5.08018 2.58329 5.99935 2.58329ZM11.8327 14.25C11.8327 14.71 11.4602 15.0833 10.9993 15.0833C10.5385 15.0833 10.166 14.71 10.166 14.25C10.166 11.9525 8.29685 10.0833 5.99935 10.0833C3.70185 10.0833 1.83268 11.9525 1.83268 14.25C1.83268 14.71 1.46018 15.0833 0.999349 15.0833C0.538516 15.0833 0.166016 14.71 0.166016 14.25C0.166016 11.0333 2.78352 8.41663 5.99935 8.41663C9.21518 8.41663 11.8327 11.0333 11.8327 14.25Z"
			fill="currentColor"
		/>
	</svg>
);
